const translation = {
  app_name: 'Hoosier Life Insurance',
};

export default translation;